module.exports = __webpack_public_path__ + "img/bg2.08d150bc.png";